import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { ADMIN_EMAILS } from '../../firebase/config';
import { ref, set } from 'firebase/database';
import { database } from '../../firebase/config';
import { FaEye, FaEyeSlash, FaGoogle } from 'react-icons/fa';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { register, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Fonction de validation du téléphone
  const validatePhone = (phone) => {
    const cleanPhone = phone.replace(/[\s\.\-]/g, '');
    const phoneRegex = /^(0[1-9]\d{8}|(\+33|0033)[1-9]\d{8})$/;
    return phoneRegex.test(cleanPhone);
  };

  // Formater le téléphone pour l'affichage
  const formatPhone = (phone) => {
    const cleanPhone = phone.replace(/[\s\.\-]/g, '');
    if (cleanPhone.length === 10) {
      return cleanPhone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
    }
    return phone;
  };

  async function handleSubmit(e) {
    e.preventDefault();

    const { nom, prenom, email, telephone, password, confirmPassword } = formData;

    if (!nom || !prenom || !email || !telephone || !password) {
      return setError('Tous les champs sont obligatoires');
    }

    if (!validatePhone(telephone)) {  
      return setError('Numéro de téléphone invalide. Veuillez entrer un numéro à 10 chiffres (ex: 0612345678)');
    }

    if (password !== confirmPassword) {
      return setError('Les mots de passe ne correspondent pas');
    }

    if (password.length < 6) {
      return setError('Le mot de passe doit contenir au moins 6 caractères');
    }

    try {
      setError('');
      setLoading(true);
      
      const userCredential = await register(email, password);
      const userId = userCredential.user.uid;
      
      const cleanPhone = telephone.replace(/[\s\.\-]/g, '');
      
      const userRef = ref(database, `utilisateurs/${userId}`);
      await set(userRef, {
        nom,
        prenom,
        nomComplet: `${prenom} ${nom}`,
        email,
        telephone: cleanPhone,
        telephoneFormatted: formatPhone(cleanPhone),
        dateInscription: new Date().toISOString(),
        role: ADMIN_EMAILS.includes(email) ? 'admin' : 'client'
      });
      
      if (ADMIN_EMAILS.includes(email)) {
        navigate('/admin/dashboard');
      } else {
        navigate('/dashboard');
      }
      
    } catch (error) {
      console.error('Erreur d\'inscription:', error);
      if (error.code === 'auth/email-already-in-use') {
        setError('Cet email est déjà utilisé');
      } else {
        setError('Erreur lors de la création du compte');
      }
    }
    setLoading(false);
  }

  async function handleGoogleSignIn() {
    try {
      setGoogleLoading(true);
      setError('');
      const result = await signInWithGoogle();
      
      // Récupérer les informations Google
      const user = result.user;
      const displayName = user.displayName || '';
      const nameParts = displayName.split(' ');
      const prenom = nameParts[0] || '';
      const nom = nameParts.slice(1).join(' ') || '';
      
      // Stocker les infos dans la base de données
      const userRef = ref(database, `utilisateurs/${user.uid}`);
      await set(userRef, {
        prenom,
        nom,
        nomComplet: displayName,
        email: user.email,
        telephone: '',
        telephoneFormatted: '',
        photoURL: user.photoURL || '',
        dateInscription: new Date().toISOString(),
        role: ADMIN_EMAILS.includes(user.email) ? 'admin' : 'client',
        provider: 'google'
      });
      
      if (ADMIN_EMAILS.includes(user.email)) {
        navigate('/admin/dashboard');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Erreur Google:', error);
      setError('Erreur lors de l\'inscription avec Google');
    }
    setGoogleLoading(false);
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Créer un compte</h2>
        <p>Rejoignez SMTD pour gérer vos déménagements</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Prénom *</label>
              <input
                type="text"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
                required
                placeholder="Jean"
              />
            </div>
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
                placeholder="Dupont"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="votre@gmail.com"
            />
          </div>

          <div className="form-group">
            <label>Téléphone *</label>
            <input
              type="tel"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              required
              placeholder="06 12 34 56 78"
            />
          </div>

          <div className="form-row">
            <div className="form-group password-group">
              <label>Mot de passe *</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Minimum 6 caractères"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <div className="form-group password-group">
              <label>Confirmer *</label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  placeholder="Confirmer"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
          </div>

          <button disabled={loading} className="btn-primary" type="submit">
            {loading ? 'Inscription en cours...' : "S'inscrire"}
          </button>
        </form>

        {/* Séparateur */}
        <div className="separator">
          <span>ou</span>
        </div>

        {/* Bouton Google */}
        <button 
          className="btn-google"
          onClick={handleGoogleSignIn}
          disabled={googleLoading}
        >
          <FaGoogle className="google-icon" />
          {googleLoading ? 'Inscription...' : 'Continuer avec Google'}
        </button>

        <p className="auth-link">
          Déjà un compte ? <Link to="/login">Connectez-vous</Link>
        </p>
        
        <p className="auth-note">
          <small>En créant un compte, vous acceptez nos conditions d'utilisation.</small>
        </p>
      </div>
    </div>
  );
};

export default Register;